'use client';

import dynamic from 'next/dynamic';

const DynamicScriptsLoader = dynamic(() => { return import('@/components/common/ScriptLoader'); }, {
  ssr: false,
});

export default function ClientScriptLoader() {
  return <DynamicScriptsLoader />;
}
